import * as React from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Avatar, CircularProgress, IconButton, Typography } from '@mui/material';
import { DamsColors } from '../../components/styles/DamsColors';
import { DamsAppAsset } from '../../assets/registry';


interface Props{

    placeholder?: string;
    handleChange?:(event: SelectChangeEvent<any>) => void,
    value?:string |number,
    items: { label: string, value: string }[],
    loading?:boolean,
    width?:string | number
    label?:string
}

export default function ControllerSelectInput({items,value,loading,handleChange,placeholder,width,label}:Props) {
  
  const isAvailable = items.find((item) => item.value === value);
  const renderValue = (value: any) => {
    if (!value) {
      return <Typography color="gray">{placeholder}</Typography>;
    }

    if (isAvailable) return isAvailable ? value : "";
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      {label &&
           <Typography
           fontFamily={"Inter"}
           fontWeight={400}
           fontSize={12}
           color={"#667085"}
         >
           {label}
         </Typography>}
      <FormControl fullWidth sx={{width}}>
        <Select
          id="controller-simple-select"
          value={value??''}
          disabled={loading}
          placeholder={placeholder}
          onChange={handleChange}
          sx={styles.selectInput}
          IconComponent={()=>null}
          endAdornment={
            <IconButton>
              {loading ? <CircularProgress size={13}/>:
              <Avatar
                src={DamsAppAsset.icons.select_arrow}
                sx={styles.arrowDownIcon}
              />}
            </IconButton>
          }
        >
         {items.map((data, index) => (
            <MenuItem value={data.value} key={`${index}`}>
              <Typography
                fontFamily={"Inter"}
                fontWeight={400}
                fontSize={15}
                color={"#667085"}
              >
                {data.label}
              </Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}const styles = {
  arrowDownIcon: {
    width: "13px",
    height: "13px",
  },

  selectInput: {
    height:35,
    padding:0,
    borderRadius: "8px",
    borderColor: `${DamsColors.Border.PageInput} !important`,
    "& .MuiSelect-select": {
      borderRadius: "8px",
      color: "#667085",
      paddingY:0,

      "&:focus": {
        borderRadius: "8px",
        borderColor: `${DamsColors.Border.PageInput} !important`,
      },

      "&:hover": {
        borderRadius: "8px",
        borderColor: `${DamsColors.Border.PageInput} !important`,
      },

      "&:active": {
        borderRadius: "8px",
        borderColor: `${DamsColors.Border.PageInput} !important`,
      },
      borderColor: `${DamsColors.Border.PageInput} !important`,
    },

    "&.Mui-focused fieldset": {
      borderColor: `${DamsColors.Border.PageInput} !important`,
      borderRadius: "8px",
    },
    "&:hover fieldset": {
      borderColor: `${DamsColors.Border.PageInput} !important`,
      borderRadius: "8px",
    },
  },
}; 